import { createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../utils/apiAuth";

export const fetchMyProjects = createAsyncThunk(
  "myProjects/fetchMyProjects",
  async (userId, { rejectWithValue }) => {
    try {
      const response = await api.get(
        `/projects/userProjects/${userId}`
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);
